export default __webpack_public_path__ + "static/media/Boots of the Sanguine Disciple (nm).71d9705e.jpg";